import React, { useLayoutEffect } from 'react';
import * as jwt from 'jsonwebtoken';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import UserService from '../../service/UserService';
import loginService from '../../service/login';
import {
  LoginSagaAction,
  AddUser,
  checkUserExist,
} from '../../sagas/saga-actions';
import LoadingSpinner from '../loadingSpinner';

const userservice = new UserService();

const Smart = (props) => {
  const history = useHistory();

  const login = async () => {
    try {
      const params = new URLSearchParams(props.location.search);
      const code = params.get('code');
      const practiceId = loginService.getUrlId();
      let userDetails = await userservice.getUserDetailsWithEhr({
        code,
        practiceId,
        ehrName: 'epic',
      });
      if (userDetails && userDetails.message === 'user not added') {
        history('/userNotFound');
        return;
      } else {
        if (typeof userDetails === 'string') {
          userDetails = JSON.parse(userDetails);
        }
        const decodedTokens = jwt.decode(userDetails.token, { complete: true });
        loginService.doLogin(decodedTokens.payload);

        props.checkUserExist(decodedTokens.payload);
        props.LoginSagaAction(decodedTokens.payload);
        loginService.doLogoutEpic();
        history.push('/chat');
      }
    } catch (err) {
      history.push({
        pathname: '/',
        state: { detail: 'Something went wrong,Please try again.' },
      });
    }
  };

  useLayoutEffect(() => {
    login();
  }, []);

  return <LoadingSpinner title="Fetching login Token" type="text" />;
};

const mapStateToProps = (state) => ({
  patients: state.patients,
});

const mapDispatchToProps = (dispatch) => ({
  LoginSagaAction: bindActionCreators(LoginSagaAction, dispatch),
  AddUser: bindActionCreators(AddUser, dispatch),
  checkUserExist: bindActionCreators(checkUserExist, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Smart);
